module.exports = __webpack_public_path__ + "static/media/BOTON WEB_Percusion.0f5f6a12.png";